import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { splitArray } from 'utils/arrayHelpers';

import { HasTypename } from './types';

/**
 * Split Folder Contents
 * Splits a Content type from raw GraphQL response containing 2 or more object types.
 * @param contents Array of objects from GraphQL response with __typename property
 * @param itemTypename Name of Content type to split out
 * @returns Tuple of Remaining items array and desired Content items array
 */
export const splitFolderContents = <FolderType extends HasTypename, ItemType extends HasTypename>(
  contents: (FolderType | ItemType)[],
  itemTypename: GRAPHQL_TYPENAMES,
) => splitArray<FolderType, ItemType>(contents, (item) => item.__typename !== itemTypename);
